module.exports = __webpack_public_path__ + "media/bootstrap-icons/megaphone-7ca517e5.svg";